/**
 * =============================================================================
 * modal-manager.js
 * =============================================================================
 * Manage modals!
 * =============================================================================
 */

var ModalManager = {
  cookiePrefix: "mp-modal-",

  /**
   * Initialisation
   */
  init: function() {
    document.querySelectorAll("[data-modal]").forEach(e => {
      let cookieNameUnprefixed = e.dataset.modalCookie;
      let delay = e.dataset.modalDelay || 300;
      console.log("[M-M] cookie name", cookieNameUnprefixed);
      console.log("[M-M] delay", delay);

      let cookieName = `${this.cookiePrefix}${cookieNameUnprefixed}`;

      let cookieNotSet = Cookies.get(cookieName) === undefined;

      if(cookieNotSet && e.dataset.modalBlock !== "true"){
        let setModalCookieElements = e.querySelectorAll("[data-modal-cookie-set]");
        setTimeout(() => {
          let modal = new bootstrap.Modal(e);
          modal.show();
        }, delay);

        setModalCookieElements.forEach(e => {
          let eventType = e.dataset.modalCookieTriggerEvent || "click";
          console.log('el', e);
          e.addEventListener(eventType, () => {
            Cookies.set(cookieName, "true", { expires: 2 });
          });
        });
      }
    });
  }
}

export default ModalManager;